import { supabase } from "../supabase";
import type { Session } from "@supabase/supabase-js";

export interface AuthGateResult {
  session: Session | null;
  allowed: boolean;
  reason: "no-session" | "ok";
}

export async function requireAuthForAI(): Promise<AuthGateResult> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) {
    return { session: null, allowed: false, reason: "no-session" };
  }
  return { session, allowed: true, reason: "ok" };
}

export function authBearerHeader(session: Session | null): string {
  return `Bearer ${session?.access_token ?? import.meta.env.VITE_SUPABASE_ANON_KEY}`;
}
